import React from 'react';
import { Mail, Globe, MapPin, Send } from 'lucide-react';
import { AppShell } from '../components/Layout';

export default function ContactScreen() {
  const email = 'contact@cytometrix.ca';
  const website = 'https://cytometrix.ca';

  return (
    <AppShell title="Contact">
      <div className="page-header">
        <h1 className="page-title">Contact Us</h1>
        <p className="page-subtitle">Get in touch with the Cytometrix team</p>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 24, alignItems: 'start' }}>
        <div className="card">
          <div className="card-header">
            <div className="card-title">
              <div className="card-icon"><Send size={16} /></div>
              Send a Message
            </div>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            <div className="form-group" style={{ marginBottom: 0 }}>
              <label className="form-label">Your Name</label>
              <input className="form-control" type="text" placeholder="Dr. Jane Smith" />
            </div>
            <div className="form-group" style={{ marginBottom: 0 }}>
              <label className="form-label">Email Address</label>
              <input className="form-control" type="email" placeholder="your@email.com" />
            </div>
            <div className="form-group" style={{ marginBottom: 0 }}>
              <label className="form-label">Subject</label>
              <input className="form-control" type="text" placeholder="How can we help?" />
            </div>
            <div className="form-group" style={{ marginBottom: 0 }}>
              <label className="form-label">Message</label>
              <textarea
                className="form-control"
                rows={5}
                placeholder="Describe your inquiry…"
                style={{ resize: 'vertical' }}
              />
            </div>
            <a
              href={`mailto:${email}`}
              className="btn btn-primary btn-full"
              style={{ textDecoration: 'none', textAlign: 'center' }}
            >
              <Mail size={16} /> Send via Email Client
            </a>
          </div>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          <div className="card">
            <div className="card-header" style={{ marginBottom: 20 }}>
              <div className="card-title">Contact Information</div>
            </div>
            {[
              { icon: Mail, label: 'Email', value: email, href: `mailto:${email}`, color: '#1B6CA8', bg: 'rgba(27,108,168,0.08)' },
              { icon: Globe, label: 'Website', value: 'www.cytometrix.ca', href: website, color: '#059669', bg: 'rgba(5,150,105,0.08)' },
              { icon: MapPin, label: 'Location', value: 'Vancouver, BC, Canada', href: null, color: '#7C3AED', bg: 'rgba(124,58,237,0.08)' },
            ].map(({ icon: Icon, label, value, href, color, bg }) => (
              <div key={label} style={{ display: 'flex', gap: 14, alignItems: 'flex-start', marginBottom: 18 }}>
                <div style={{ width: 40, height: 40, borderRadius: 'var(--radius-sm)', background: bg, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                  <Icon size={18} color={color} />
                </div>
                <div>
                  <div style={{ fontSize: '0.72rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.06em', color: 'var(--text-muted)', marginBottom: 2 }}>{label}</div>
                  {href ? (
                    <a href={href} target={label === 'Website' ? '_blank' : undefined} rel="noopener noreferrer"
                      style={{ fontSize: '0.9rem', color, textDecoration: 'none', fontWeight: 500 }}>
                      {value}
                    </a>
                  ) : (
                    <span style={{ fontSize: '0.9rem', color: 'var(--text-secondary)', fontWeight: 500 }}>{value}</span>
                  )}
                </div>
              </div>
            ))}
          </div>

          <div className="card" style={{ background: 'linear-gradient(135deg, var(--navy), var(--navy-mid))', border: 'none' }}>
            <div style={{ marginBottom: 16 }}>
              <img src="/logo.png" alt="Cytometrix" style={{ height: 30, filter: 'brightness(0) invert(1)' }} />
            </div>
            <p style={{ fontSize: '0.875rem', color: 'rgba(255,255,255,0.6)', lineHeight: 1.7 }}>
              We're committed to advancing wound care through innovation. Our team responds to clinical and technical inquiries within one business day.
            </p>
            <a
              href={website}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-outline"
              style={{ marginTop: 20, color: '#fff', borderColor: 'rgba(255,255,255,0.3)', textDecoration: 'none', display: 'inline-flex' }}
            >
              <Globe size={15} /> Visit Website
            </a>
          </div>

          <div className="alert alert-info" style={{ margin: 0 }}>
            <div>
              <strong>Clinical Support:</strong> For urgent clinical questions, please contact your local wound care specialist or healthcare provider directly.
            </div>
          </div>
        </div>
      </div>
    </AppShell>
  );
}
